export default {"src":"/_next/static/media/golf.3acf4558.svg","height":32,"width":119,"blurWidth":0,"blurHeight":0};